import { DynamicContentType, Rounded, Shadow } from '../../types/content.types.js'
import { FileEntryBM } from '../../types/fileEntry.types.js'
import { LucideIconName } from '../../types/lucide.types.js'

export type GalleryData = {
  images: (FileEntryBM | undefined)[]
  marginBottom?: string
  marginTop?: string
  rounded?: Rounded
  shadow?: Shadow
}

export const gallery: DynamicContentType<GalleryData> = {
  name: 'gallery',
  viewName: 'Bildgalleri',
  featureKey: 'gallery',
  icon: LucideIconName.Images,
  uuid: '',
  default: true,
  data: {
    images: [undefined, undefined, undefined],
  },
}
